import React, { useCallback, useMemo } from 'react';
import { useLockFn } from 'ahooks';

import cx from './index.module.scss';

interface Props {
  className?: string;
  value: string | number | [number, number];
  steps: { value: string; label: string }[];
  onChange: (value: string) => void | Promise<void>;
}

const ModeSwitch: React.FC<Props> = ({ value, onChange, className, steps = [] }) => {
  const calcSliderOffset = useMemo(() => {
    const valueIdx = steps?.findIndex(item => String(item.value) === String(value));
    return valueIdx === -1 ? '-100%' : `${valueIdx * (100 / steps?.length)}%`;
  }, [steps, value]);

  const handleOnClickItem = useLockFn(
    useCallback(
      async (item: typeof steps[0]) => {
        if (item.value !== value) {
          await onChange?.(item.value);
        }
      },
      [onChange, value]
    )
  );

  return (
    <div className={cx('ModeSwitch', className)}>
      <div className={cx('slide-box')}>
        {steps?.map(item => (
          <div
            className={cx('slide-item', 'custom-slide-item', { active: String(item.value) === String(value) })}
            onClick={() => handleOnClickItem(item)}
            key={item.value}
          >
            {item.label}
          </div>
        ))}
        <div className={cx('slider-wrapper')} style={{ width: `${100 / steps?.length}%`, left: calcSliderOffset }}>
          <div className={cx('slider', 'custom-slider')} />
        </div>
      </div>
    </div>
  );
};

export default ModeSwitch;
